import { Schema } from '@cak-legacy/generation-core';
import { IPageFlowStep } from '@cak-legacy/shared-generic-rekenmodule';

export const resultsStep: IPageFlowStep = {
  name: 'verzonden',
  isReadOnly: true,
  isResultStep: true,
  categoryName: 'verzonden',
  getSchema: (variables: any) => (): Schema => ({}), //leeg schema, wordt afgevangen door aanroep "renderResultPage" in isResultStep in GenericRekenmodule
};
